/**
 * Parses a page reference string (e.g., "21, 49, 58-60") into an array of individual page numbers
 * @param pageString - A string containing page numbers and ranges (e.g., "21, 49, 58-60")
 * @returns An array of page numbers
 */
export const parsePageReferences = (pageString: string): number[] => {
    const pages: number[] = [];
    const parts = pageString.split(",").map((part) => part.trim());

    for (const part of parts) {
        if (part.includes("-")) {
            // Handle range (e.g., "58-60")
            const [start, end] = part
                .split("-")
                .map((num) => parseInt(num.trim()));
            if (!isNaN(start) && !isNaN(end)) {
                for (let i = start; i <= end; i++) {
                    pages.push(i);
                }
            }
        } else {
            // Handle single page number
            const pageNum = parseInt(part.trim());
            if (!isNaN(pageNum)) {
                pages.push(pageNum);
            }
        }
    }

    return pages;
};
